
(function () {
  "use strict";

  function showToast(message, options) {
    var opts = options || {};
    var type = opts.type || "error";
    var duration = Number(opts.duration) > 0 ? Number(opts.duration) : 4000;
    var toastId = opts.id || "n4y-toast";

    var existingToast = document.getElementById(toastId);
    if (existingToast && existingToast.parentNode) {
      existingToast.parentNode.removeChild(existingToast);
    }

    var toast = document.createElement("div");
    toast.id = toastId;
    toast.setAttribute("role", "alert");
    toast.textContent = message || "Something went wrong. Please try again.";

    var bgColor = "#b91c1c";
    if (type === "success") bgColor = "#166534";
    if (type === "info") bgColor = "#1d4ed8";

    toast.style.position = "fixed";
    toast.style.bottom = "2rem";
    toast.style.right = "2rem";
    toast.style.zIndex = "9999";
    toast.style.maxWidth = "36rem";
    toast.style.padding = "1rem 1.25rem";
    toast.style.borderRadius = "8px";
    toast.style.backgroundColor = bgColor;
    toast.style.color = "#ffffff";
    toast.style.boxShadow = "0 8px 20px rgba(0, 0, 0, 0.15)";
    toast.style.fontSize = "1.4rem";
    toast.style.lineHeight = "1.4";

    document.body.appendChild(toast);

    window.setTimeout(function () {
      if (toast && toast.parentNode) {
        toast.parentNode.removeChild(toast);
      }
    }, duration);
  }

  window.N4YToast = window.N4YToast || {};
  window.N4YToast.show = showToast;
})();
